import styled from 'styled-components';
import checkmark from '../../../../assets/logos/checkmark.svg';

const PEARL_BORDER = '#8dbbb8';
const PEARL_SELECTED = '#2b4344';
const PEARL_TEXT = '#040404';
const PEARL_MUTED = '#464646';
const PEARL_ACCENT = '#4a8280';
const PEARL_BADGE = '#4a8280';

const Tile = styled.div`
    border: ${({ isSelected }) =>
        isSelected ? `2px solid ${PEARL_SELECTED}` : `1px solid ${PEARL_BORDER}`};
    border-radius: 8px;
    padding: ${({ isPopular }) => (isPopular ? '40px 0 0 0' : '16px 0 0 0')};
    padding-bottom: 0px;
    width: 276px;
    max-width: 100%;
    text-align: left;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    transition: max-height 0.3s ease;
    box-sizing: border-box;

    @media (max-width: 815px) {
        padding: ${({ isPopular }) => (isPopular ? '36px 0 0 0' : '12px 0 0 0')};
        padding-bottom: 0px;
    }

    .saveButton {
        width: 100%;
        color: #e8184c;
        background: white;
        border: 2px solid;
        label {
            b {
                text-transform: none;
                font-weight: 700;
                font-size: 14px;
                text-align: center;
            }
        }
    }
`;

const TileBody = styled.div`
    display: flex;
    flex-direction: column;
`;

const Title = styled.h4`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: ${PEARL_TEXT};
    margin: 0px;
    text-transform: none;
    padding-right: 16px;
    padding-left: 16px;
    @media (max-width: 815px) {
        margin-top: ${({ isPopular }) => !isPopular && '4px'};
        padding-top: ${({ isPopular }) => isPopular && '8px'};
        font-size: 18px;
    }
`;

const Price = styled.h3`
    font-weight: 500;
    font-size: 20px;
    margin: 0px;
    line-height: 32px;
    color: ${PEARL_TEXT};
`;
const Duration = styled.h4`
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    color: ${PEARL_TEXT};
    margin: 0 0 0 4px;
`;

const Period = styled.div`
    margin-top: 10px;
    margin-bottom: 15px;
    font-weight: 300;
    font-size: 12px;
`;

const Description = styled.p`
    font-weight: 400;
    font-family: 'Objektiv Mk2', sans-serif;
    font-size: 14px;
    line-height: 21px;
    color: ${PEARL_MUTED};
    margin-bottom: 0px;
    margin-top: 0px;
    padding-right: 16px;
    padding-left: 16px;
`;

const Benefits = styled.ul`
    list-style: none;
    padding: 0 16px 16px;
    margin: 0;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 12px;

    .benefitItem {
    }
`;

const BenefitItem = styled.div`
    margin: 0;
    display: inline-flex;
    align-items: flex-start;
    gap: 8px;
`;
const Checkmark = styled.span`
    content: url(${checkmark});
    width: 15px;
    height: 12px;
    flex-shrink: 0;
    margin-top: 4px;
`;

const Benefit = styled.li`
    font-size: 14px;
    line-height: 21px;
    font-weight: 400;
    color: ${PEARL_MUTED};
`;

const TrialLink = styled.a`
    color: red;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 5px;
`;

const Highlight = styled.span`
    color: red;
`;

const PopularBadge = styled.div`
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    background-color: ${PEARL_BADGE};
    color: white;
    padding-top: 8px;
    padding-bottom: 8px;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.02em;
    text-align: center;
    border-radius: 8px 8px 0 0;
    @media (max-width: 815px) {
        top: 0px;
    }
`;

const ToggleIcon = styled.span`
    font-size: 1.5em;
    transition: transform 0.2s ease;
    color: ${PEARL_SELECTED};

    @media (min-width: 769px) {
        display: none;
    }
`;

const HiddenRadio = styled.input`
    display: none;
`;

const PriceContainer = styled.div`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    margin: 16px 0 0;
    padding-right: 16px;
    padding-left: 16px;
`;

const PlanInfo = styled.div`
    color: ${PEARL_ACCENT};
    font-family: 'Objektiv Mk2', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    padding-right: 16px;
    margin-top: 12px;
    padding-left: 16px;
`;

const PlanImageWrap = styled.div`
    width: 100%;
    margin-top: 8px;

    img {
        display: block;
        width: 100%;
        max-width: 276px;
        height: auto;
        margin: 0 auto;
        border-radius: 0 0 6px 6px;
    }
`;

export {
    Tile,
    Title,
    Price,
    Period,
    Description,
    Benefits,
    Benefit,
    TrialLink,
    Highlight,
    PopularBadge,
    ToggleIcon,
    HiddenRadio,
    TileBody,
    Duration,
    PriceContainer,
    PlanInfo,
    Checkmark,
    BenefitItem,
    PlanImageWrap,
};
